import React from 'react';
import cn from 'classnames';

const ViewInput = ({ input, index, styles, t, basicData = false }) => {
  return input.value ? (
    <div
      key={index}
      className={cn(
        'my-3',
        styles[basicData ? 'main-input' : 'input'],
        styles['col-2-4'],
      )}
    >
      <h5 className={styles[basicData ? 'main-label' : 'label']}>
        {t(input.label)}
      </h5>
      <p
        className={cn(
          styles[basicData ? 'main-value' : 'value'],
          input.valueClassName ? styles[input.valueClassName] : '',
        )}
      >
        {input.value}
      </p>
    </div>
  ) : null;
};

export default React.memo(ViewInput);
